<template>
  <div class="fast-select-time">
    <div class="dateTimepicker">
      <el-date-picker
        v-model="dateTime"
        type="datetimerange"
        range-separator="至"
        style="width: 330px"
        start-placeholder="开始时间"
        :clearable="false"
        @change="dateTimeChange"
        end-placeholder="结束时间"
      >
      </el-date-picker>
    </div>
    <div></div>
    <el-radio-group class="radio-group" v-model="cycNum" @change="searchFormcycNumChange">
      <el-radio :label="1">天</el-radio>
      <el-radio :label="2">周</el-radio>
      <el-radio :label="3">月</el-radio>
      <el-radio :label="4">季</el-radio>
    </el-radio-group>
  </div>
</template>
<script>
export default {
  props: ['times'],
  data() {
    return {
      cycNum: '',
      dateTime: [],
    };
  },
  watch: {
    times(val) {
      this.resetTime(val);
    },
  },
  created() {
    this.dateTime = this.times;
  },
  methods: {
    resetTime(time) {
      if (time) {
        this.dateTime = time;
      } else {
        this.dateTime = [];
      }
      // this.cycNum = ''
    },
    dateTimeChange(e) {
      console.log(123);
      console.log(e);
      this.times = e;
      this.$emit('update:times', e);
    },
    searchFormcycNumChange(val) {
      let arr = [];
      switch (val) {
        case 1:
          arr = [this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')), this.dayjs()];
          break;
        case 2:
          arr = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1, 'week'),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ];
          break;
        case 3:
          arr = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1, 'month'),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ];
          break;
        case 4:
          arr = [
            this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(3, 'month'),
            this.dayjs().format('YYYY-MM-DD 23:59:59'),
          ];
          break;
      }
      this.dateTime = arr;
      this.dateTimeChange(arr);
    },
  },
};
</script>
<style scoped>
.fast-select-time {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.dateTimepicker {
  min-width: 330px;
  flex-shrink: 1;
  flex-grow: 1;
  width: 330px;
  max-width: 340px;
}
.radio-group {
  margin-left: 10px;
  min-width: 250px;
  flex-shrink: 0;
  flex-grow: 0;
  /* border: 1px solid #f00; */
}
</style>
